var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"fieldset"},[_c('div',{staticClass:"form-row"},[_c('field-box',{attrs:{"name":"property_valuable[valuable_type]","label":_vm.$t('forms.valuable_type'),"type":"select","options":_vm.valuableTypeOptions,"disabled":_vm.disabled,"has-error":_vm.errors?.['property_valuable.valuable_type']?.length}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }